export default __webpack_public_path__ + "static/media/paint-07 (1).6fe74a5b.jpg";